import { z } from 'zod';

export const PaisSchema = z.object({
    pai_descricao: z.string(),
    pai_idpk: z.number(),
});

export const CidadeSchema = z.object({
    cid_cidade: z.string(),
    cid_ibge: z.string(),
    cid_idpk: z.number(),
    cid_pais_idpk: z.number(),
    cid_timezone: z.string(),
    cid_uf: z.string(),
    cid_ultima_alteracao: z.string().nullable(),
    pais: PaisSchema,
});

export type Cidade = z.infer<typeof CidadeSchema>;
